import React from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useQuery } from "@apollo/client";
import { TagQuery } from "arena/queries";
import ThumbnailCardMedia from "arena/components/ThumbnailCardMedia";
import Link from "arena/components/Link";

const StyledThumbnailCardMedia = styled(ThumbnailCardMedia)(({ theme }) => ({
  height: 0,
  paddingTop: "56.25%", // 16:9
  position: "relative",
  [theme.breakpoints.up("sm")]: {
    borderRadius: 4,
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  "& a": {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  "& img": {
    maxWidth: "100%",
    height: "auto",
  },
}));

export default function ArenaTagCard({ tagId, maxWidth = "md" }) {
  const { data, loading } = useQuery(TagQuery, {
    skip: !tagId,
    variables: {
      id: tagId,
    },
  });

  if (loading) return null;

  const tag = data?.tag;

  if (!tag) return null;

  return (
    <Container maxWidth={maxWidth} sx={{ p: 0, pt: 3 }}>
      <Card>
        {tag.image && (
          <StyledThumbnailCardMedia
            thumbnails={tag.image.thumbnails}
            alt={tag.title}
            size="MAXRES"
          />
        )}

        <CardHeader
          title={
            <Link
              to={tag.url}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {tag.title}
            </Link>
          }
        />

        {tag.html && (
          <CardContent sx={{ pt: 0 }}>
            <Text
              variant="body1"
              dangerouslySetInnerHTML={{ __html: tag.html }}
            />
          </CardContent>
        )}
      </Card>
    </Container>
  );
}

ArenaTagCard.propTypes = {
  tagId: PropTypes.string.isRequired,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
};
